// extracted by mini-css-extract-plugin
module.exports = {"clickableChip":"styles_clickableChip__12tM1"};